import { type CSSProperties } from 'react';

import { FONT_INTER, PAGE_BODY_PADDING } from '../shared/blueprint-view-styles';

/**
 * PDF revision log styles:
 * Header: backgroundColor #666, color white, fontWeight bold, fontSize 14px, padding 8px
 * Data row 0: borderBottom 1px solid #ccc (initial creation row)
 * Data rows: alternating bg white / #f5f5f5, borderBottom 1px solid #eee
 *
 * fontSize 14px matches the rest of the blueprint body (see OVERVIEW_BODY_STYLE)
 */

export const REVISION_BODY_STYLE: CSSProperties = {
	flex: 1,
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'center',
	padding: PAGE_BODY_PADDING,
	fontFamily: FONT_INTER
};

export const REVISION_ADD_ROW_BUTTON_STYLE: CSSProperties = {
	marginTop: '12px',
	padding: '4px 12px',
	fontSize: '11px',
	color: '#666',
	backgroundColor: 'white',
	border: '1px solid #ccc',
	borderRadius: '4px',
	cursor: 'pointer',
	transition: 'opacity 0.15s'
};

export const REVISION_TABLE_STYLE: CSSProperties = {
	borderCollapse: 'collapse',
	width: '90%',
	lineHeight: 1.4
};

export const REVISION_COL_REV_STYLE: CSSProperties = { width: '10%' };
export const REVISION_COL_DATE_STYLE: CSSProperties = { width: '15%' };
export const REVISION_COL_DESC_STYLE: CSSProperties = { width: '60%' };
export const REVISION_COL_ENG_STYLE: CSSProperties = { width: '15%' };

export const REVISION_HEADER_CELL_STYLE: CSSProperties = {
	backgroundColor: '#666',
	color: 'white',
	fontWeight: 700,
	fontSize: '14px',
	padding: '8px',
	textAlign: 'center'
};

export const REVISION_DATA_CELL_STYLE: CSSProperties = {
	fontSize: '14px',
	padding: '8px',
	height: '40px',
	verticalAlign: 'middle',
	textAlign: 'center'
};
